<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="ip_address_is_load" parent="ip_address">
    <tab id="info" :name="translate('ip_profile.section.info')" :href="url+'/info'">
      <IPAddressInfo v-if="ip_address_is_load"
        :ip_address="ip_address_info"
        @update="get_ip_address"
        @update_ip_info="update_ip_info"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              IP Address: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/ip_addressing/list'}">
              To IP Address list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import IPAddressInfo from './Tabs/Info/Index.vue'

export default {
  name: 'IP_address',
  components: {
    IPAddressInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      ip_address_info: null,
    }
  },

  computed: {
    url () { return '/ip_address/' + this.$route.params.ip_address_id },
    cur_id () { return this.$route.params.ip_address_id },
    load () { return !this.ip_address_info?.id },
    ip_address_is_load() { return this.ip_address_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'ip_address_section') {
        this.get_ip_address()
      }
    }
  },

  activated(){
    this.get_ip_address()
  },

  methods: {
    update_ip_info(info){
      this.ip_address_info = info
    },
    get_ip_address () {
      this.$http.v1.getIPS(this.$route.params.ip_address_id, (response) => {
        this.ip_address_info = response.data
      })
    }
  }
}

</script>
